import { useDispatch, useSelector } from 'react-redux';

/**
 * The hooks components use to reach the store.
 *
 * Thin on purpose. Their value is that every component imports state access
 * from one module: when the store grows a middleware, a devtools binding, or a
 * different react-redux major, there is one place to change rather than an
 * import in every file.
 */
export const useAppDispatch = useDispatch;
export const useAppSelector = useSelector;
